export const FORM_FIELD_NAMES = {
    REG_TYPE: "registrationType",
    DEFAULT_MANAGER_ID: "defaultAffiliateManagerId",
    PASSWORD_SETUP_FLOW: 'passwordSetupFlow'
}

export const SECTION_ITEMS = [
    {
        title: "backoffice.registrationform.contactDetailFields",
        controls: ["UserName", "Password", "ConfirmPassword", "FirstName", "LastName", "Email", "PhoneNumber", "Country", "State", "City", "Address", "ZipCode", "ContactChannel",]
    },

    {
        title: "backoffice.registrationform.paymentDetailFields",
        controls: ["PaymentMethod", "CurrencyCode"]
    },

    {
        title: "backoffice.registrationform.additionalFields",
        controls: ["AdditionalInfo", "TargetMarket", "TrafficSource", "ReceiveNewsletter", "RegulatorAffiliateId", "AffiliateAgreementId"]
    }
];